<script setup lang="ts">
import {QBtn, useDialogPluginComponent} from "quasar";
import Translator from "@/utils/common/Translator.ts";
import NamaIcon from "@/components/icons/NamaIcon.vue";
import NamaLinearProgress from "@/components/progress/NamaLinearProgress.vue";
import {ref, watch} from "vue";
import {storeToRefs} from "pinia";
import {useLoginInfoStore} from "@/stores/loginInfo.ts";
import NaMaText = namaTypes.NaMaText;
import GUIActionResult = namaTypes.GUIActionResult;

const {dialogRef, onDialogOK, onDialogCancel} = useDialogPluginComponent();
const {tasks} = storeToRefs(useLoginInfoStore());
const props = defineProps<{ pendingResponseId: string; title: NaMaText; }>()
const namaProgressRef = ref();

watch(() => tasks.value, (task) => {
  let result = tasks.value?.find(l => l.pendingResponseId === props.pendingResponseId) ?? {};
  if (result && !result.processing)
    onDialogOK(result);
})

function onCancel() {
  onDialogCancel();
}

function onMinimize() {
  onDialogOK({pendingResponseId: props.pendingResponseId, progressTitle: props.title} as GUIActionResult);
}

</script>

<template>
  <q-dialog ref="dialogRef" @hide="onCancel" :persistent="true">
    <q-card class="tw-shadow-none dark:tw-bg-namaBackground-deep-dark tw-bg-namaBackground-deep-light !tw-rounded-none tw-min-w-[430px]">
      <q-bar class="tw-text-xs  tw-bg-primary-light tw-text-white dark:tw-bg-primary-dark dark:tw-text-white tw-h-10">
        <div v-text="Translator.translateNaMaText(title)"/>
        <q-space/>
        <q-btn dense flat @click="onMinimize" :title="Translator.translateId('minimize')"
               class="nama-btn-hover nama-custom-btn focus:tw-bg-transparent">
          <q-avatar square class="tw-w-5">
            <NamaIcon defaultIcon="minimize" class="active-white"/>
          </q-avatar>
        </q-btn>
      </q-bar>
      <q-card-section class="tw-pb-0">
        <NamaLinearProgress ref="namaProgressRef" :pendingResponseId="pendingResponseId"/>
      </q-card-section>
      <q-card-section class="tw-flex tw-flex-row tw-gap-4 tw-justify-center tw-pt-0">
        <q-btn
          :label="Translator.translateId('cancel')"
          dense @click="onCancel"
          class="tw-bg-primary-light dark:tw-bg-primary-dark tw-text-white tw-text-base tw-font-normal tw-rounded-md tw-min-w-[90px]"/>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<style scoped>

</style>
